import { Component, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { Observable } from 'rxjs'
import { AuthFacade } from '../../../../auth/auth.facade'
import { CognitoUserInfo } from '../../../../auth/cognito-user-info'
import { PpwLocalStorageService } from '../../../../common/services/ppwlocalstorage.service'
import { SnackbarService } from '../../../../common/services/snackbar.service'
import { notUndefined } from '../../../../common/utils/conditional-assert'
import { ProfilePreferences } from '../profile/profile-preferences.model'

@Component({
    selector: 'app-profile-preferences',
    templateUrl: './profile-preferences.component.html',
    styleUrls: ['./profile-preferences.component.scss']
})
export class ProfilePreferencesComponent implements OnInit {
    profilePreferences?: ProfilePreferences
    dialogTitle = 'Preferences'
    preferencesShowDetailColumnForTimecards!: boolean
    preferencesShowArchivedData!: boolean
    hasChanges = false
    currentUser$: Observable<CognitoUserInfo | null> = this.auth.getCurrentUser()
    private readonly prefix = 'ProfilePreferencesComponent'
    async ngOnInit(): Promise<void> {
        await this.getPreferences()
    }

    constructor(
        private readonly ppwLocalStorageService: PpwLocalStorageService,
        private readonly dialogRef: MatDialogRef<ProfilePreferencesComponent>,
        private readonly snackBar: SnackbarService,
        private readonly auth: AuthFacade
    ) {}

    closeDialog(): void {
        this.dialogRef.close()
    }
    execute(): void {
        const preferenceMessage = 'Preferences updated'
        const settingPreferences = this.preferencesHaveChanges()

        if (settingPreferences) {
            this.copyPreferencesToProfilePreferences()
            this.ppwLocalStorageService.storeData(
                this.ppwLocalStorageService.STORAGE_KEY_PROFILE_PREFERENCES,
                this.profilePreferences
            )
            this.profilePreferences = this.ppwLocalStorageService.getStoredData(
                this.ppwLocalStorageService.STORAGE_KEY_PROFILE_PREFERENCES
            )
            this.copyPreferencesToController()
            this.snackBar.promtSnackBar(preferenceMessage)
            this.closeDialog()
        }
    }

    showDetailColumn(event: boolean): void {
        this.preferencesShowDetailColumnForTimecards = event
        this.checkHasChanges()
    }

    showArchivedData(event: boolean): void {
        this.preferencesShowArchivedData = event
        this.checkHasChanges()
    }

    private async getPreferences(): Promise<void> {
        try {
            this.profilePreferences = this.ppwLocalStorageService.getStoredData(
                this.ppwLocalStorageService.STORAGE_KEY_PROFILE_PREFERENCES
            )
            await this.copyPreferencesToController()
        } catch (err) {
            this.snackBar.handleError(this.prefix, err, true)
        }
    }

    private checkHasChanges(): void {
        this.hasChanges =
            notUndefined(this.profilePreferences).showDetailColumnForTimecards !==
                this.preferencesShowDetailColumnForTimecards ||
            notUndefined(this.profilePreferences).showArchivedData !== this.preferencesShowArchivedData
    }

    private copyPreferencesToProfilePreferences(): void {
        notUndefined(this.profilePreferences).showDetailColumnForTimecards =
            this.preferencesShowDetailColumnForTimecards
        notUndefined(this.profilePreferences).showArchivedData = this.preferencesShowArchivedData
    }

    private preferencesHaveChanges(): boolean {
        return (
            notUndefined(this.profilePreferences).showDetailColumnForTimecards !==
                this.preferencesShowDetailColumnForTimecards ||
            notUndefined(this.profilePreferences).showArchivedData !== this.preferencesShowArchivedData
        )
    }

    private copyPreferencesToController(): void {
        if (!this.profilePreferences) {
            this.profilePreferences = new ProfilePreferences()
        }

        this.preferencesShowDetailColumnForTimecards = this.profilePreferences.showDetailColumnForTimecards
        this.preferencesShowArchivedData = this.profilePreferences.showArchivedData
    }
}
